module.exports = __webpack_public_path__ + "static/chauntea-symbol-SCAG-0ffad0d510f89640ad1ad5bd0d662a2d.png";